import { type Theme } from '@mui/material/styles';

import { type SingleDimension } from '../../types/dimensions';
import { type QuantitativeSize, type QuantitativeSizeString } from '../../types/sizes';
import { type Color } from '../../util/colors';

export enum AvatarDiscreteSize {
  Large = 'large',
  Small = 'small',
  XLarge = 'xl',
}

export const isAvatarDiscreteSize = (size: unknown): size is AvatarDiscreteSize =>
  Object.values(AvatarDiscreteSize).includes(size as AvatarDiscreteSize);

export type AvatarSize =
  | AvatarDiscreteSize
  | QuantitativeSize<'px'>
  | SingleDimension<QuantitativeSizeString<'%'>>;

export const avatarSizeIsResponsive = (
  size: AvatarSize | SingleDimension<QuantitativeSizeString<'%'>>,
): size is SingleDimension<QuantitativeSizeString<'%'>> =>
  typeof size === 'object' && ('width' in size || 'height' in size);

export interface AvatarStyleProps {
  readonly backgroundColor?: ((t: Theme) => string) | Color | null;
  readonly borderColor?: ((t: Theme) => string) | Color | null;
  /**
   * @default t => t.palette.background.default
   */
  readonly color?: ((t: Theme) => string) | Color;
  readonly fontSize?: ((t: Theme) => string) | QuantitativeSize<'px' | 'rem'>;
  readonly size?: AvatarSize;
}
